module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-welcome-board-0c7cefa527e4cdd6244ce135991e8e34.png";